







import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: "QrNone"
})
export default class QrNone extends Vue {

}
